<div
  class="milestone-comment-component"
  [style.padding-left]="isGlobalView ? '30px' : '0'"
  [style.padding-right]="isGlobalView ? '30px' : '0'"
  [style.padding-bottom]="isGlobalView ? '30px' : '0'"
  [style.padding-top]="'0'">
  @if (isGlobalView) {
    <div class="d-flex justify-content-end" (click)="closeModal()">
      <i class="fa fa-times pointer my-3"></i>
    </div>
  }
  @if (comments?.length) {
    <div class="comment-list d-flex flex-column mb-2">
      @for (comment of comments; track comment) {
        <div class="comment-element d-flex flex-column">
          <div class="comment-menu">
            <i class="fa fa-pencil p-1 pointer" title="Edit" (click)="editComment(comment)"></i>
            <i class="fa fa-trash p-1 pointer" title="Delete" (click)="deleteComment(comment)"></i>
          </div>
          <div class="d-flex flex-fill align-items-center">
            <div class="me-2">
              <mtm-user-profile-picture
                [user]="getUser(comment.username)"
                [username]="comment.username"
                [height]="29"
                [width]="29" />
            </div>
            <div class="d-flex flex-column">
              <div class="_bold username">
                {{ getUserInfo(comment.username) }}
              </div>
              <div class="timestamp">{{ comment.dateTime | commentDate }}</div>
            </div>
          </div>
          <div class="flex-fill my-2">
            @if (editedCommentId !== comment.id) {
              <mtm-comment-preview [value]="comment.commentText" />
            } @else {
              <mtm-text-editor
                class="flex-fill"
                [participants]="participants"
                [(value)]="comment.commentText"
                [enableEnterSubmit]="true"
                (enterKeyPress)="updateComment(comment)"
                (keydown.enter)="$event.preventDefault()"
                (keyup)="$event.stopPropagation()"
                (click)="$event.stopPropagation()" />
            }
          </div>
          <div class="reply-comment-section pointer d-flex flex-column">
            <div
              class="d-flex align-items-center reply-btn"
              [ngClass]="{ 'mb-2': replyId == comment.id }"
              (click)="expandReply(comment)">
              <mtm-user-profile-picture
                [user]="getUser(authUser.username)"
                [username]="authUser.username"
                [height]="20"
                [width]="20" />
              <span class="text-uppercase _bold mx-1">{{ 'reply' | translate }}</span>
              @if (comment.replyCount) {
                <span>({{ comment.replyCount }})</span>
              }
            </div>
            @if (replyId === comment.id) {
              <div class="reply-comment-list comment-list d-flex flex-column">
                @for (reply of comment.replies; track reply) {
                  <div class="comment-element d-flex flex-column">
                    <div class="comment-menu">
                      <i class="fa fa-pencil p-1 pointer" title="Edit" (click)="editComment(reply)"></i>
                      <i class="fa fa-trash p-1 pointer" title="Delete" (click)="deleteComment(reply)"></i>
                    </div>
                    <div class="d-flex flex-fill align-items-center">
                      <div class="me-2">
                        <mtm-user-profile-picture
                          [user]="getUser(reply.username)"
                          [username]="reply.username"
                          [height]="29"
                          [width]="29" />
                      </div>
                      <div class="d-flex flex-column">
                        <div class="username _bold">
                          {{ getUserInfo(reply.username) }}
                        </div>
                        <div class="timestamp">{{ reply.dateTime | commentDate }}</div>
                      </div>
                    </div>
                    <div class="flex-fill my-2">
                      @if (editedCommentId !== reply.id) {
                        <mtm-comment-preview [value]="reply.commentText" />
                      } @else {
                        <mtm-text-editor
                          class="flex-fill"
                          [participants]="participants"
                          [(value)]="reply.commentText"
                          [enableEnterSubmit]="true"
                          (enterKeyPress)="updateComment(reply)"
                          (keyup)="$event.stopPropagation()"
                          (keydown.enter)="$event.preventDefault()"
                          (click)="$event.stopPropagation()" />
                      }
                    </div>
                  </div>
                }
                <div class="new-reply-comment">
                  <mtm-text-editor
                    class="flex-fill"
                    [participants]="participants"
                    [(value)]="newReplyComment"
                    [enableEnterSubmit]="true"
                    (enterKeyPress)="onSendNewComment(replyId)"
                    (keydown.enter)="$event.preventDefault()"
                    (keyup)="$event.stopPropagation()"
                    (click)="$event.stopPropagation()" />
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <div class="new-comment">
    <mtm-text-editor
      class="flex-fill"
      [participants]="participants"
      [(value)]="newComment"
      [enableEnterSubmit]="true"
      (enterKeyPress)="onSendNewComment()"
      (keydown.enter)="$event.preventDefault()"
      (keyup)="$event.stopPropagation()"
      (click)="$event.stopPropagation()" />
  </div>
</div>
